










import { AdgroupFormData } from '@tt4b/ttam-enums';
import { useStore } from '@tt4b/ttam-hooks';
import { i18n } from '@tt4b/ttam-i18n';
import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api';

const name = 'ttam-tracking-compose-tip';
export default defineComponent({
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      defualt: () => ({}),
    },
  },
  setup(props) {
    const { adgroupData } = toRefs(props);
    const { state } = useStore();
    const aadvid = computed(() => state.baseInfo.value.aadvid);
    const eventManagerTip = computed(() =>
      i18n.t('module_adgroup_dpa_appretarget_em_tip', {
        advid: aadvid.value,
        bc_id: adgroupData.value.catalogAuthorizedBc,
      }),
    );
    return {
      name,
      eventManagerTip,
    };
  },
});
